/**
 * MSAL stores a temporary "interaction in progress" flag in browser storage.
 * If the user closes the tab, hits Back, or a redirect fails before MSAL clears it,
 * the flag can remain and every new `loginRedirect` throws `interaction_in_progress`.
 */
export function clearMsalBrowserInteractionLock(): void {
  if (typeof window === 'undefined') {
    return;
  }
  for (const storage of [window.localStorage, window.sessionStorage]) {
    try {
      for (const key of Object.keys(storage)) {
        if (key === 'msal.interaction.status' || /\.interaction\.status$/.test(key)) {
          storage.removeItem(key);
        }
      }
    } catch {
      /* private mode / quota */
    }
  }
}

export function isMsalInteractionInProgressError(err: unknown): boolean {
  if (!err || typeof err !== 'object') {
    return false;
  }
  const rec = err as Record<string, unknown>;
  if (rec['errorCode'] === 'interaction_in_progress') {
    return true;
  }
  const msg = rec['message'];
  return typeof msg === 'string' && msg.includes('interaction_in_progress');
}
